import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';

import PublicExchangeForm from '@/components/PublicExchangeForm.vue';
import { i18n, i18nSetPublicLocale } from '@/i18n/index.js';
import { initialDataParser } from '@/utilities/initialData';
import assetStore from '@/store/assets/index';
import { TokenService } from '@paybis/frontend-common-lib/src/publicApi';

async function init(props: object, lang: string, basePath: string) {
    if (!document) {
        return;
    }

    let headingStyles: string = '';
    const heading = document.getElementById('form-heading');

    if (heading !== null) {
        headingStyles = heading.getAttribute('style') ?? '';
    }

    const routes: RouteConfig[] = [
        {
            path: '/:buyLink?/',
            name: 'Home',
            component: PublicExchangeForm,
            pathToRegexpOptions: {
                strict: true,
            },
            props: {
                ...props,
                lang,
                headingStyles,
            },
        },
    ];

    const defaultLocale = 'en';
    const { defaultBuyLink } = props;

    const router = new VueRouter({
        base: `${ basePath }/${ lang !== defaultLocale ? lang : '' }`,
        mode: 'history',
        routes,
    });

    router.beforeEach((to, from, next) => {
        if (to.params.buyLink === defaultBuyLink) {
            // XXX: we don't want to add `buy-bitcoin-with-credit-card` in the URL
            next({
                path: '/',
            });
        } else {
            next();
        }
    });

    await Promise.all([
        i18nSetPublicLocale(lang),
        // XXX: we should still allow app to continue and launch
        assetStore.dispatch('assets/init').catch(() => {}),
        TokenService.hasToken() ? assetStore.dispatch('feature/init').catch(() => {}) : null,
    ]);

    new Vue({
        router,
        i18n,
        render: h => h('router-view'),
    }).$mount('#exchange-form-app');
}

const { lang, props, basePath = '' } = initialDataParser(
    'exchangeForm',
    ['lang', 'props', 'basePath'],
);

init(props, lang, basePath);
